
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 3328 3328","shape-rendering":"geometricPrecision","text-rendering":"geometricPrecision","image-rendering":"optimizeQuality","fill-rule":"evenodd","clip-rule":"evenodd"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M487 487C812 162 1238 0 1664 0s852 162 1177 487 487 751 487 1177-162 852-487 1177-751 487-1177 487-852-162-1177-487S0 2090 0 1664 162 812 487 487zm1074 357c0-50 40-90 90-90s90 40 90 90v742h742c50 0 90 40 90 90s-40 90-90 90h-742v742c0 50-40 90-90 90s-90-40-90-90v-742H819c-50 0-90-40-90-90s40-90 90-90h742V844zm102-664c-380 0-759 145-1049 435s-435 669-435 1049 145 759 435 1049 669 435 1049 435 759-145 1049-435 435-669 435-1049-145-759-435-1049-669-435-1049-435z","fill-rule":"nonzero"}})])
          )
        }
      }
    